import http from "@/api.js";
import fileDownload from 'js-file-download';

export default {
    name: 'document-mixin',
    emits: [
        "ask-create-document",
        "edit-document-reset",
        "edit-document",
        "new-document",
        "replace-document",
        "view-document",
    ],
    data: () => ({
        dataroomdocumentUpload: null,
        dataroominputReplace: null,
        document_history: [],
        documents_uploaded: [],
        document_url: null,
        document_callback: null,
        document_url_api_suffix: "",
    }),
    props: {
        ask_documents: { type: [Object, Array], default() { return [] } },
        documents: { type: Array, default: [] },
    },
    computed: {
        document_messages_actions(){
            return {
                print_color: [
                    this.gettext("Imprimer en noir et blanc"),
                    this.gettext("Imprimer en couleur"),
                ],
                print_both_sides: [
                    this.gettext("Imprimer en recto"),
                    this.gettext("Imprimer en recto-verso"),
                ],
                in_email: [
                    this.gettext("Retirer de l'email"),
                    this.gettext("Ajouter a l'email"),
                ],
                in_postal: [
                    this.gettext("Retirer du courrier"),
                    this.gettext("Ajouter au courrier"),
                ],
                in_space: [
                    this.gettext("Retirer de l'espace invité"),
                    this.gettext("Ajouter à l'espace invité"),
                ],
            }
        }
    },
    methods: {
        // a simplifier
        emitEditDocument(document){
            this.$emit(document.is_template || document.is_from_template ? 'edit-document-template' : 'edit-document', document)
        },
        isTplOrAsk(document){
            return document.is_from_template_without_file || document.ask_name;
        },
        actionOnTplOrAsk(document){
            if((document.is_template || document.is_from_template_without_file) && !this.readonly){
                this.$emit("edit-document-template", document);
            }else{
                window.open(document.url_viewer);
            }
        },

        documentActionMsg(document, action){
            return this.document_messages_actions[action][document[action] ? 0 : 1];
        },

        documentsAskMissed(documents){
            if(!this.ask_documents || this.ask_documents.length == 0)
                return [];
            return this.ask_documents.filter(ask => {
                return !documents.find(doc => {
                    if(doc.asked == ask.name || doc.name == ask.name){
                        return true;
                    }
                });
            });
        },
        documentsAskStatus(documents){
            let doc_available = documents.filter(doc => doc?.uid);
            return this.ask_documents.map(ask => {
                const doc = doc_available.find(doc => doc.last_version.asked?.startsWith(ask.name));
                if(doc) {
                    doc.ask_name = ask.name;
                    doc.desc = ask.desc;
                    doc.is_encrypted = ask?.is_encrypted;
                    return doc;
                }
                return { ask_name: ask.name, desc: ask.desc, folder: this.init_uid, is_encrypted: ask?.is_encrypted };
            });
        },

        documentsOnLevel(documents){
            documents = documents || [];
            if(this.readonly)
                return documents.filter(document => document.last_version?.file);
            documents = documents.concat(this.documentsAskMissed(documents).map(doc => ({ask_name: true, name: doc.name, folder: this.init_uid})));
            return documents;
        },

        // Actions new document modal
        startNewDocument($event){ this.openModalDataroom('create-document', $event); },
        async actionGenerateNewDocument(raw_template, data){
            await http.post(this.fileUrl(), {
                raw_template,
                folder: data.uid,
                generate: data.newdocument_name,
                template_cfg: data.template_cfg,
            });
            this.$emit("new-document", data.uid);
        },
        async actionDownloadNewDocument(raw_template, data){
            const response = await http.post(this.documentUrl(null, "download_preview/"), {
                raw_template,
                folder: data.folder,
                template_cfg: data.template_cfg,
            }, {responseType: 'arraybuffer'});
            var cd = response.headers["content-disposition"];
            const fn = cd.match("filename=(.+)")[1];
            fileDownload(response.data, fn);
        },

        // View document
        startViewDocument($event){
            this.openModalDataroom('view-document', $event);
        },
        getUrlDocument(document){
            http.get(this.documentUrl(document.uid)+"url/").then(response => {
                this.document_url = response.data.url;
            });
        },

        // Actions edit document modal
        startEditDocument($event){ this.openModalDataroom('edit-document', $event); },
        async actionGenerateEditDocument(raw_template, data){
            await http.post(this.fileUrl(), {
                raw_template,
                folder: data.folder,
                generate: data.name,
                template_cfg: data.template_cfg,
            });
            this.$emit("edit-document", data.folder);
        },
        async actionDownloadEditDocument(raw_template, data){
            const response = await http.post(this.documentUrl(null, "download_preview/"), {
                raw_template,
                folder: data.folder,
                generate: data.name,
                template_cfg: data.template_cfg,
            }, {responseType: 'arraybuffer'});
            var cd = response.headers["content-disposition"];
            const fn = cd.match("filename=(.+)")[1];
            fileDownload(response.data, fn);
        },

        // Uploaded documents
        getDocumentsUploaded(){
            const api = this.document_url_api + this.document_url_api_suffix;
            return http.get(api).then((response) => {
                this.documents_uploaded = response.data;
            });
        },

        // Reset/History
        startResetDocument($event){ this.openModalDataroom('edit-document-reset', $event); },
        getDocumentHistory(document){
            http.get(this.documentUrl(document.uid)+"versions/").then(response => {
                this.document_history = response.data;
            });
        },
        resetDocumentHistory(document, version){
            if (confirm(this.interpolate(this.gettext('Êtes-vous sûr de vouloir restaurer le document à la version du %s ?'), [version.formated_date_update]))) {
                http.post(this.documentUrl(document.uid, "reset/"), {version: version.uid}).then(()=> {
                    this.$emit('edit-document', document.folder);
                    this.$emit("close");
                });
            }
        },

        // Set in (email, postal, space)
        setDocumentIn(document, in_uid){
            http.put(this.documentUrl(document.uid), {[in_uid]: !document[in_uid]}).then(() => {
                document[in_uid] = !document[in_uid];
            });
        },

        // Remove document
        doRemoveDocument(document){
            return http.delete(this.documentUrl(document.uid));
        },
        startRemoveDocument(document, callback){
            if (confirm(this.interpolate(this.gettext('Êtes-vous sûr de vouloir supprimer le document %s ?'), [document.name]))) {
                this.doRemoveDocument(document).then(() => {
                    this.$emit('folder-change', document.folder);
                    if(callback) callback();
                });
            }
        },

        sendEmailDocument(document){
            const email = prompt(this.interpolate(this.gettext("Entrez l'email ou envoyer le document %s"), [document.name]));
            if(email){
                http.post(this.documentUrl(document.uid, "email/"), { email })
                    .then(() => {
                        this.toastMessage(this.interpolate(this.gettext('document envoyé a l\'email %s'), [email]))
                    });
            }
        },

        async startDownloadDocument(document){
            const response = await http.get(this.documentUrl(document.uid, "download/"), {responseType: 'arraybuffer'});
            var cd = response.headers["content-disposition"];
            const fn = cd.match("filename=(.+)")[1];
            fileDownload(response.data, fn);
        },

        // Replace
        startReplaceDocument(doc, callback){
            this.document_callback = callback;
            this.dataroomdocumentUpload = doc;
            this.dataroomuploadFunction = this.doReplaceDocument;
            this.dataroominputReplace = document.createElement("input");
            this.dataroominputReplace.setAttribute("type", "file");
            this.dataroominputReplace.setAttribute("multiple", "false");
            this.dataroominputReplace.setAttribute("style", "display: none");
            this.dataroominputReplace.addEventListener("change", this.doReplaceDocument);
            this.dataroominputReplace.addEventListener("cancel", this.doReplaceDocument);
            document.body.appendChild(this.dataroominputReplace);
            this.dataroominputReplace.click();
        },
        async doReplaceDocument($event){
            const files = $event.target.files;
            console.log("doReplaceDocument", files);
            console.log("upload data", this.dataroomdocumentUpload);
            if(files.length > 0){
                const api = this.file_url_api + this.file_url_api_suffix;
                for (let i = 0; i < files.length; i++) {
                    // Create a new Blob object from the file
                    let blob = files[i].slice(0, files[i].size, files[i].type);
                    // Create a new FormData object
                    let formData = new FormData();
                    // Append the blob to the FormData object with the desired name
                    if(this.dataroomdocumentUpload.is_encrypted){
                        formData.append('is_encrypted', true);
                    }
                    if(this.dataroomdocumentUpload.ask_name){
                        formData.append('asked', this.dataroomdocumentUpload.ask_name);
                        this.dataroomdocumentUpload.name = files[i].name;
                    }
                    formData.append('file', blob, this.dataroomdocumentUpload.name);
                    formData.append('folder', this.dataroomdocumentUpload.folder);
                    await http.postForm(api, formData, {
                        onUploadProgress: (progressEvent) => {
                            if(this.document_callback)
                                this.document_callback({event: progressEvent, action: "progress", document: this.dataroomdocumentUpload});
                        },
                    });
                }
                this.dataroominputReplace.removeEventListener("change", this.doReplaceDocument);
                this.dataroominputReplace.removeEventListener("cancel", this.doReplaceDocument);
                document.body.removeChild(this.dataroominputReplace);
                this.dataroominputReplace = null;
                this.$emit("folder-change", this.dataroomdocumentUpload.folder);
                if(this.document_callback)
                    this.document_callback({action: "reload", document: this.dataroomdocumentUpload});
            }
            this.file_url_api_suffix = "";
            this.dataroomdocumentUpload = null;
        },

        // Contextual menu
        openContextualMenuDocument($event, document){
            var menu = [];
            if(document.last_version?.file){
                menu.push({ label: this.gettext('Télécharger'), function: () => this.startDownloadDocument(document) });
                //menu.push({ label: gettext('Envoyer par email'), function: () => this.sendEmailDocument(document) });
                menu.push({ label: this.gettext('Remplacer par un document personnel'), function: () => this.startReplaceDocument(document) });
            }
            //if(document.has_event_model && !this.readonly){
            //    menu.push({ label: this.documentActionMsg(document, 'in_email'), function: () => this.setDocumentIn(document, "in_email") });
            //    menu.push({ label: this.documentActionMsg(document, 'in_postal'), function: () => this.setDocumentIn(document, "in_postal") });
            //    menu.push({ label: this.documentActionMsg(document, 'in_space'), function: () => this.setDocumentIn(document, "in_space") });
            //}
            if(!document.is_template && !document.ask_name && !this.readonly){
                menu.push({ label: this.documentActionMsg(document, 'print_both_sides'), function: () => this.setDocumentIn(document, "print_both_sides") });
                menu.push({ label: this.documentActionMsg(document, 'print_color'), function: () => this.setDocumentIn(document, "print_color") });
            }
            if(document.template && !this.readonly){
                menu.push({ label: this.gettext('Editer le document'), function: () => this.$emit("edit-document-template", document) });
                if(document.template_actions && !document.is_template_overwrited){
                    Object.entries(document.template_actions).forEach(([key, value]) => {
                        menu.push({
                            label: value,
                            function: () => {
                                this.actionActionTemplate(document, key);
                            },
                        });
                    });
                }
                if(document.is_template_overwrited){
                    menu.push({ label: this.gettext('Réinitialiser le document'), function: () => this.actionResetTemplate(document) });
                }
            }
            if(!document.is_template && !document.ask_name && !document.is_from_template){
                menu.push({ label: this.gettext('Supprimer le document'), function: () => this.startRemoveDocument(document) });
            }
            if(document.ask_name) {
                menu.push({ label: this.gettext('Ajouter le document'), function: () => this.$emit("add-document", document.name) });
            }
            if(menu.length > 0)
                this.CtxMenuOpen($event, { menu });
        },
    }
}
